import { render, staticRenderFns } from "./OrderTerms.vue?vue&type=template&id=3450215b&scoped=true&"
import script from "./OrderTerms.vue?vue&type=script&lang=js&"
export * from "./OrderTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3450215b",
  null
  
)

export default component.exports